import { r as registerInstance, h, H as Host } from './index-cc222d37.js';

const ttuiCardCss = ":host{border-radius:var(--card-border-radius);box-shadow:0px 4px 8px rgb(45 45 45 / 8%);display:block;margin-bottom:var(--gutter)}";

const Card = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
Card.style = ttuiCardCss;

const ttuiContainerCss = ":host{display:block;padding:var(--gutter)}:host([ttui-metadata]){text-align:right;padding:var(--half-gutter) var(--gutter)}";

const Container = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
Container.style = ttuiContainerCss;

const ttuiSeparatorCss = ":host{border-bottom:1px solid rgba(45, 45, 45, 0.16);display:block}";

const Separator = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
Separator.style = ttuiSeparatorCss;

export { Card as C, Separator as S, Container as a };

//# sourceMappingURL=ttui-separator-cf3b070d.js.map